import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/**
 * Allows only internal EmitRoll staff into the admin area. Prefers the server's
 * explicit `isSystemAdmin` boolean but also honours a `SystemAdmin` JWT role
 * claim (see AuthService.isSystemAdmin). Unauthenticated users go to login;
 * other signed-in users are redirected to the app's default route.
 */
export const systemAdminOnly: CanMatchFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn())     { return router.parseUrl('/auth/login'); }
  if (!auth.isSystemAdmin())  { return router.parseUrl('/'); }
  return true;
};
